export default "__VITE_ASSET__ChqjGTqA__"